import { Checkbox, Empty, Popover, Table } from 'antd';
import classes from 'components/customer/engagements/Timeline.module.scss';
import LinkButton from 'components/shared/button/LinkButton';
import React, { useState, useEffect } from 'react';
import { Fade } from 'react-awesome-reveal';
import { Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { exportData } from 'store/customer/customer-view-actions';
import { exportToExcel } from 'utils/utils';
import styles from './ConfigurableTable.module.scss';
import OverlayTrigger from '../tooltip/Tooltip';

const ConfigurableTable = ({
  rows,
  customCss,
  columns,
  expandRowByClick,
  enableColumnSelection,
  enableExport,
  exportFileName,
  showActionIcon,
  actionColumnTitle,
  actionColumnWidth,
  iconProps,
  onActionClickHandler,
  tableName,
  isGlobalExport,
  pagination,
  isGlobalSort,
  onSort,
  timePeriod,
  basicSort,
  tableType,
  filterExp,
  dimentions,
}) => {
  const isEmailIcon = iconProps?.iconCss === 'e-mail' ? true : false;
  //const isActionIcon = iconProps?.iconCss === 'card-toggle' ? true : false;
  const [selectedColumns, setSelectedColumns] = useState(
    columns.map((column) => {
      return column.isMandatory === 'Y' && column.key;
    })
  );
  useEffect(() => {
    setSelectedColumns(
      columns.map((column) => {
        return column.isMandatory === 'Y' && column.key;
      })
    );
  }, [columns]);

  const affiliationExpression = useSelector(
    (state) => state?.CustomerView?.affiliationsExpression
  );

  const [popoverVisible, setPopoverVisible] = useState(false);
  const [activeExpRow, setActiveExpRow] = React.useState();
  const qlikToken = localStorage.getItem('qlikToken');
  const qlikCookie = localStorage.getItem('qlikCookie');
  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );
  const siteExpression = useSelector(
    (state) => state?.CustomerView?.siteExpression
  );
  const excludeColumnFromExcel = useSelector(
    (state) => state?.CustomerView?.excelColumnsRestiction
  );

  const productMixExpression = useSelector(
    (state) => state?.CustomerView?.productMixExpression
  );

  const copayExpression = useSelector(
    (state) => state?.CustomerView?.copayCustomColumn
  );

  const hcpFlag = useSelector((state) => state?.CustomerView.hcpFlag);

  const dispatch = useDispatch();

  const handleColumnSelection = (checkedValues) => {
    setSelectedColumns(checkedValues);
  };

  const handlePopoverVisibleChange = (visible) => {
    setPopoverVisible(visible);
  };

  const filteredColumns = columns.filter((column) =>
    selectedColumns.includes(column.key)
  );

  const exportTableData = () => {
    if (tableName === 'Affiliation') {
      dispatch(
        exportData(
          tableName,
          selectedCustomer?.value,
          qlikCookie,
          qlikToken,
          hcpFlag,
          affiliationExpression
        )
      );
    } else if (tableName === 'SitePerformance') {
      dispatch(
        exportData(
          tableName,
          selectedCustomer?.value,
          qlikCookie,
          qlikToken,
          siteExpression,
          timePeriod,
          '',
          '',
          excludeColumnFromExcel
        )
      );
    } else if (tableName === 'ProductMix') {
      dispatch(
        exportData(
          tableName,
          selectedCustomer?.value,
          qlikCookie,
          qlikToken,
          productMixExpression,
          timePeriod
        )
      );
    } else if (tableName === 'CopayAnalytics') {
      dispatch(
        exportData(
          tableName,
          selectedCustomer?.value,
          qlikCookie,
          qlikToken,
          copayExpression,
          undefined
        )
      );
    } else if (tableName === 'SiteAffiliation') {
      dispatch(
        exportData(
          tableName,
          selectedCustomer?.value,
          qlikCookie,
          qlikToken,
          null,
          null,
          null,
          affiliationExpression
        )
      );
    }
  };

  const handleCheckboxChange = (event) => {};

  const columnSelectionPanel = (
    <Checkbox.Group
      defaultValue={selectedColumns}
      onChange={handleColumnSelection}
      className={styles.checkboxGroup}>
      {columns.map((column) => (
        <div
          className={styles.checkboxWrapper}
          key={column.id}>
          <Checkbox
            className={styles.checkbox}
            key={column.key}
            value={column.key}
            disabled={column.key === 'percentage_life_covered'}
            onChange={handleCheckboxChange}>
            {column.title}
          </Checkbox>
        </div>
      ))}
    </Checkbox.Group>
  );

  const customColumns = [
    ...filteredColumns,
    {
      title: () =>
        enableColumnSelection && (
          <Popover
            content={popoverContent}
            trigger='click'
            open={popoverVisible}
            onOpenChange={handlePopoverVisibleChange}>
            <span className='d-flex'>
              <i
                className={`icon icon__affiliations_standardTable_settings`}
              />{' '}
            </span>
          </Popover>
        ),
      dataIndex: 'columnSelection',
      fixed: 'right',
      width: 65,
      key: 'columnSelection',
      render: () => null,
    },
    {
      title: () =>
        enableExport && (
          <span
            className='d-flex'
            onClick={() =>
              isGlobalExport
                ? exportTableData()
                : exportToExcel(rows, columns, exportFileName)
            }>
            <i className={`icon icon__affiliations_standardTable_excel`} />{' '}
          </span>
        ),
      dataIndex: 'columnSelection',
      key: 'columnSelection',
      render: () => null,
    },
  ];

  const customColumnsWithoutSelection = [
    ...filteredColumns,
    {
      title: actionColumnTitle
        ? actionColumnTitle
        : () =>
            enableExport && (
              <span
                className='d-flex'
                onClick={() =>
                  isGlobalExport
                    ? exportTableData()
                    : exportToExcel(rows, columns, exportFileName)
                }>
                <i
                  className={`icon icon__affiliations_standardTable_excel`}
                />{' '}
              </span>
            ),
      dataIndex: 'columnSelection',
      width: actionColumnWidth || 70,
      fixed: iconProps?.iconCss === 'view' ? 'right' : 'none',
      align: tableName === 'myViews' ? 'right' : undefined,
      key: 'columnSelection',
      render: (_, record) =>
        showActionIcon && (
          <>
            <LinkButton
              className={`ms-0 me-0 ps-0 d-inline-block ${classes['icon-wrapper']}`}
              onClick={(e) => onActionClickHandler(record, e)}>
              {isEmailIcon ? (
                <OverlayTrigger
                  overlay={
                    <Tooltip className='gne-tooltip'>
                      <span className='text text__x-small'>
                        {`Click here to email the POC`}
                      </span>
                    </Tooltip>
                  }>
                  <i className={`mx-3 icon icon__${iconProps?.iconCss}`}></i>
                </OverlayTrigger>
              ) : (
                <i className={`m-0 icon icon__${iconProps?.iconCss}`}></i>
              )}
            </LinkButton>
          </>
        ),
    },
  ];

  const popoverContent = (
    <div className={styles.customPopup}>{columnSelectionPanel}</div>
  );

  const CustomExpandIcon = ({ expanded, onExpand, record }) => {
    return expandRowByClick && record?.children && record?.children?.length ? (
      <span
        className={`${styles.expandIcon} ant-table-row-expand-icon`}
        style={{ paddingRight: '10px' }}>
        {!expanded ? (
          <i className={`icon icon__affiliations_pivotTable_expand`} />
        ) : (
          <i className={`icon icon__affiliations_pivotTable_collapse`} />
        )}
      </span>
    ) : null;
  };
  const expandableConfig = {
    expandRowByClick: expandRowByClick,
    indentSize: 0,
    rowExpandable: (record) =>
      expandRowByClick === true && record.children?.length > 0,
    expandIcon: CustomExpandIcon,
    expandedRowKeys: activeExpRow,
    onExpand: (expanded, record) => {
      const keys = [];
      if (expanded) {
        keys.push(record.id);
      }
      setActiveExpRow(keys);
    },
  };

  const modifiedRows = rows?.map((item, index) => ({
    ...item,
    key: index + 1,
    id: index + 1,
  }));

  const paginationConfigs = pagination
    ? {
        ...pagination,
        showSizeChanger:
          pagination?.showSizeChanger && pagination?.disabledPageSizehandler
            ? {
                disabled: true,
                popupRender: (menu) => <>{menu}</>,
              }
            : pagination.showSizeChanger,
        itemRender: (page, type, originalElement) => {
          if (type === 'next') {
            return (
              <button
                className={styles.nextButton}
                disabled={true}>
                Next
              </button>
            );
          } else if (type === 'prev') {
            return (
              <button
                className={styles.nextButton}
                disabled={true}>
                Previous
              </button>
            );
          }
          return originalElement;
        },
      }
    : pagination;

  const handleTableChange = (pagination, filters, sorter) => {
    if (isGlobalSort && sorter && sorter.column) {
      const { dataIndex } = sorter.column;
      onSort(dataIndex, sorter.order, pagination, filters);
    } else {
      onSort(undefined, undefined, pagination, filters);
    }
  };
  const locale = {
    emptyText: <Empty />,
  };
  return (
    <Fade cascade>
      <Table
        locale={locale}
        dataSource={modifiedRows}
        columns={
          enableColumnSelection ? customColumns : customColumnsWithoutSelection
        }
        className={
          customCss
            ? `${customCss} engagement-table`
            : `custom-table gne-table engagement-table`
        }
        expandable={expandableConfig}
        pagination={paginationConfigs}
        scroll={
          dimentions
            ? { x: dimentions?.x, y: dimentions?.y }
            : { x: 1000, y: 400 }
        }
        onChange={!basicSort ? handleTableChange : null}
        showSorterTooltip={false}
      />
    </Fade>
  );
};
export default ConfigurableTable;
